import { MediaType } from './media-type.enum';

export class FileType {
  static audio = ['m4a', 'wav', 'wma', 'mp3', 'aac', 'ac-3', 'adpcm', 'amr', 'dsd', 'mp1', 'mp2', 'pcm', 'realaudio'];
  static video = ['mkv', 'rmvb', 'avi', 'wmv', '3gp', 'flv', 'rm', 'mov', 'mp4', 'mpg', 'webm', 'ts', 'asf', 'm3u8'];
  static document = ['xls', 'xlsx', 'xlsm', 'pdf', 'ppt', 'pptx', 'doc', 'docx', 'txt'];
  static image = ['png', 'jpg', 'jpeg'];
  static zip = ['zip'];
  static rar = ['rar'];

  static isAudio(fileType: string): boolean {
    fileType = fileType.toLowerCase();
    return this.audio.indexOf(fileType) >= 0;
  }

  static isVideo(fileType: string): boolean {
    fileType = fileType.toLowerCase();
    return this.video.indexOf(fileType) >= 0;
  }

  static isMedia(fileType: string): boolean {
    return this.isAudio(fileType) || this.isVideo(fileType);
  }

  static isMediaByFilename(filename: string): boolean {
    let filetype = this.getFileType(filename);
    return this.isMedia(filetype);
  }

  static isDocument(fileType: string): boolean {
    fileType = fileType.toLowerCase();
    return this.document.indexOf(fileType) >= 0;
  }

  static isImage(fileType: string): boolean {
    fileType = fileType.toLowerCase();
    return this.image.indexOf(fileType) >= 0;
  }

  static isZip(fileType: string): boolean {
    fileType = fileType.toLowerCase();
    return this.zip.indexOf(fileType) >= 0;
  }

  static isRar(fileType: string): boolean {
    fileType = fileType.toLowerCase();
    return this.rar.indexOf(fileType) >= 0;
  }

  static getCatalog(filename: string): MediaType {
    let type = this.getFileType(filename);
    if (this.audio.indexOf(type) >= 0) {
      return MediaType.AUDIO;
    }
    if (this.video.indexOf(type) >= 0) {
      return MediaType.VIDEO;
    }
    if (this.image.indexOf(type) >= 0) {
      return MediaType.IMAGE;
    }
    if (this.document.indexOf(type) >= 0) {
      return MediaType.DOCUMENT;
    }
    if (this.zip.indexOf(type) >= 0 || this.rar.indexOf(type) >= 0) {
      return MediaType.ZIP;
    }
    return MediaType.DOCUMENT;
  }

  static getFileType(filename: string): string {
    return filename.substr(filename.lastIndexOf('.') + 1).toLowerCase();
  }

  static isSupportedType(filename: string): boolean {
    let type = this.getFileType(filename);
    return this.isMedia(type) || this.isDocument(type) || this.isImage(type) || this.isZip(type) || this.isRar(type);
  }
}
